module.exports = __webpack_public_path__ + "img/H-45-ST-550-BB.5921db6f.png";